import { render, staticRenderFns } from "./customNumberInput.vue?vue&type=template&id=83afeb52&scoped=true"
import script from "./customNumberInput.vue?vue&type=script&lang=js"
export * from "./customNumberInput.vue?vue&type=script&lang=js"
import style0 from "./customNumberInput.vue?vue&type=style&index=0&id=83afeb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83afeb52",
  null
  
)

export default component.exports